import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Space, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { SearchOptions } from '../TableHelper'
import { Pagination } from 'components/Pagination'

type MappingSpecieListProps = BaseListComponentProps & {
  loading: boolean,
  mappingSpecies: any,
  pagination: any,
  filters: any | null,
  history?: any,

  loadMappingSpecies: (args: SearchRequest) => void,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingSpecieList extends ListComponent<MappingSpecieListProps> {

  static defaultProps = {
    loading: false,
    mappingSpecies: [],

    loadMappingSpecies: () => {}
  }

  tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: any, b: any) => a.name - b.name
    },
    {
      title: 'Partner',
      dataIndex: 'partner_key',
      key: 'partner_key',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.partner_key - b.name
    },
    {
      title: 'External ID',
      dataIndex: 'external_id',
      key: 'external_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.external_id - b.external_id
    },
    {
      title: 'Species',
      dataIndex: ['specie', 'name'],
      key: 'specie_id',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.specie?.name - b.specie?.name
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size='middle'>
          <Link to={`specie/${record.uuid}`} ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      )
    }
  ]

  componentDidUpdate(prevProps: any, prevState: any) {
    this.validateAccessPermissions()

    if (prevProps.filters !== this.props.filters) {
      this.load()
    }
  }
  
  protected load() {
    this.searchOptions = {
      search: {
        ...this.props.filters,
        specie: {
          with: true
        }
      },
      options: {
        ...this.searchOptions.options,
        _force_ids: true,
        sort: ['-id']
      }
    }

    this.props.loadMappingSpecies(this.searchOptions)

    if (this.props.onLoad) {
      this.props.onLoad(this.searchOptions)
    }
  }

  render() {
    const { loading, pagination, mappingSpecies, loadMappingSpecies } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={mappingSpecies}
          onChange={(pagination: any, filters: any, sorter: any) => this.handleTableChange(pagination, sorter, loadMappingSpecies)}
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={mappingSpecies?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadMappingSpecies)
          }
        />
      </>
    )
  }
}
